


// export default QuizPreviewComponent;
import React, { useEffect, useState } from "react";
import { Card, Checkbox, Radio, Divider, Badge, Tooltip, Spin, Alert, Steps, Button, Modal, List, Tag, Progress } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import courseService from "../../services/course.service";
import MatchingQuestionViewer from "./MatchingQuestionViewer"; // adapte le chemin selon ton projet
import { CheckCircleTwoTone, FileTextOutlined, InfoCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import { recalculateNote } from "../../actions/noteActions"; // ✅ importer ton action

const { Step } = Steps;

// const QuizPreviewComponent = ({ quizId, attemptOnce = false }) => {
const TestDeConnaissance = ({ quizId, courseId, attemptOnce = false }) => {
const dispatch = useDispatch();


  // console.log("🧪 attemptOnce prop value:", attemptOnce); // 🐞 trace ici
  const isAttemptOnce = attemptOnce === true || attemptOnce === 1;

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userAnswers, setUserAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [threshold, setThreshold] = useState(0);
  const [isGeneratingBadge, setIsGeneratingBadge] = useState(false);
  const [downloading, setDownloading] = useState(false); // 🌀 état du spinner
  const [reviewResults, setReviewResults] = useState([]);

  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [score, setScore] = useState(0);
  const [myscore_stored, setmyscore_stored] = useState(0);

  const [resultSaved, setResultSaved] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [progress, setProgress] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);


  // useEffect(() => {
  //   console.log("🔍 Quiz ID reçu dans TestDeConnaissance:", quizId);
  //   alert("Composant TestDeConnaissance reçoit le quiz ID : " + quizId);
  // }, [quizId]);


  useEffect(() => {
    const loadThreshold = async () => {
      try {
        if (!courseId) {
          console.warn("❗ courseId manquant pour récupération du seuil");
          return;
        }
        const fetchedThreshold = await courseService.getThreshold(courseId);
        console.log("🎯 Seuil récupéré du backend :", fetchedThreshold);
        setThreshold(fetchedThreshold);
      } catch (err) {
        console.error("Erreur lors de la récupération du seuil :", err);
      }
    };
    loadThreshold();
  }, [courseId]);


  // ✅ Récupération user depuis localStorage en dehors du useEffect
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.id || null;

  useEffect(() => {
    const loadProgress = async () => {
      try {
        if (!courseId || !userId) {
          console.warn("❗ Paramètres manquants pour récupération du progrès");
          return;
        }

        // Appel à ton service backend
        const fetchedProgress = await courseService.CalculePrgresseByType(
          "controle", // ou "evaluation" / "training"
          courseId,
          userId,
          quizId
        );

        console.log("📊 Progression récupérée du backend :", fetchedProgress);
        setProgress(fetchedProgress);
      } catch (err) {
        console.error("❌ Erreur lors de la récupération du progrès :", err);
      }
    };

    loadProgress();
  }, [courseId, userId, quizId]); // ✅ userId est maintenant accessible


  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };


  useEffect(() => {
    const fetchReview = async () => {
      if (!submitted || !quizId) return;

      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const review = await courseService.getQuizReviewResults(user.id, quizId);
        setmyscore_stored(review[0].score)
        setReviewResults(review);
        // alert(" review data " + JSON.stringify(review[0].score))
        console.log("🔁 Résultat de la revue chargé :", review);
      } catch (error) {
        console.error("Erreur chargement revue quiz :", error);
      }
    };

    fetchReview();
  }, [submitted, quizId]);


  const isQuestionCorrect = (question) => {
    const correctIds = question.correctAnswers.map(a => a.answerId).sort().join(",");
    const userIds = question.userAnswers.map(a => a.answerId).filter(Boolean).sort().join(",");
    return correctIds === userIds;
  };



  const DragDropPreview = ({ question }) => {

    const [items, setItems] = useState(
      question.options.map((opt, index) => ({
        id: `option-${index}`,
        content: opt.text,
      }))
    );

    const onDragEnd = (result) => {
      if (!result.destination) return;
      const reordered = Array.from(items);
      const [moved] = reordered.splice(result.source.index, 1);
      reordered.splice(result.destination.index, 0, moved);
      setItems(reordered);
    };






    return (
      <div style={{ backgroundColor: "#f1f8e9", padding: "16px", borderRadius: "10px" }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable-options">
            {(provided) => (
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ listStyleType: "none", paddingLeft: 0 }}
              >
                {items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          padding: "10px",
                          marginBottom: "8px",
                          backgroundColor: snapshot.isDragging ? "#c8e6c9" : "#e8f5e9",
                          border: "1px solid #c8e6c9",
                          borderRadius: "5px",
                          ...provided.draggableProps.style,
                        }}
                      >
                        {item.content}
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  };

  useEffect(() => {
    const loadQuiz = async () => {
      try {
        const questionList = await courseService.getQuestionsByQuiz(quizId);

        // **** avant afficher l'ordre des réponses drag and drop aléatoirement ***
        // const questionsWithOptions = await Promise.all(
        //   questionList.map(async (question) => {
        //     if (question.questionType === "MATCHING") {
        //       const matchingPairs = await courseService.getMatchingPairsByQuestion(question.id);
        //       return { ...question, options: matchingPairs };
        //     } else {
        //       const options = await courseService.getAnswersByQuestion(question.id);
        //       const correctAnswers = options.filter((opt) => opt.isCorrect).map((opt) => opt.text);
        //       return { ...question, options, correctAnswers };
        //     }
        //   })
        // );

        // **** aprés afficher l'ordre des réponses drag and drop aléatoirement ***
        const questionsWithOptions = await Promise.all(
          questionList.map(async (question) => {
            if (question.questionType === "MATCHING") {
              const matchingPairs = await courseService.getMatchingPairsByQuestion(question.id);
              return { ...question, options: matchingPairs };
            } else {
              const options = await courseService.getAnswersByQuestion(question.id);
              const correctAnswers = options.filter((opt) => opt.isCorrect).map((opt) => opt.text);

              // 🔀 Mélange les options uniquement si DRAG_DROP
              const shuffledOptions = question.questionType === "DRAG_DROP" ? shuffleArray(options) : options;

              return { ...question, options: shuffledOptions, correctAnswers };
            }
          })
        );

        setQuestions(questionsWithOptions);
      } catch (err) {
        console.error("Erreur chargement quiz preview :", err);
        setError("Erreur lors du chargement du quiz.");
      } finally {
        setLoading(false);
      }
    };
    loadQuiz();
  }, [quizId]);




  const buildAnswersPayload = () => {
    const answersArray = [];

    questions.forEach((question) => {
      const userAnswer = userAnswers[question.id];

      if (typeof userAnswer === "string") {
        const answer = question.options.find((opt) => opt.text === userAnswer);
        if (answer) {
          answersArray.push({
            questionId: question.id,
            answerId: answer.id,
          });
        }
      } else if (Array.isArray(userAnswer)) {
        userAnswer.forEach((answerText) => {
          const answer = question.options.find((opt) => opt.text === answerText);
          if (answer) {
            answersArray.push({
              questionId: question.id,
              answerId: answer.id,
            });
          }
        });
      } else if (question.questionType === "MATCHING" && typeof userAnswer === "object") {
        const pairs = question.options || [];
        pairs.forEach((pair) => {
          const selected = userAnswer[pair.leftText];
          const answer = question.options.find(
            (opt) => opt.leftText === pair.leftText && opt.rightText === selected
          );
          if (answer && answer.id) {
            answersArray.push({
              questionId: question.id,
              answerId: answer.id,
            });
          }
        });
      }

      // Pour DRAG_DROP, tu peux ajouter plus tard une logique de sauvegarde d'ordre si nécessaire
    });

    return answersArray;
  };

  useEffect(() => {
    const fetchInitialReview = async () => {
      if (!quizId) return;

      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const review = await courseService.getQuizReviewResults(user.id, quizId);

        if (review && review.length > 0) {
          // Convertir review vers format userAnswers
          const reconstructedAnswers = {};

          review.forEach((question) => {
            const type = question.questionType;

            if (type === "QCU" || type === "VRAI_FAUX") {
              reconstructedAnswers[question.questionId] = question.userAnswers[0]?.text || "";
            } else if (type === "QCM") {
              reconstructedAnswers[question.questionId] = question.userAnswers.map(a => a.text);
            } else if (type === "MATCHING") {
              const map = {};
              question.userAnswers.forEach((a) => {
                map[a.leftText] = a.rightText;
              });
              reconstructedAnswers[question.questionId] = map;
            }
            // Pour DRAG_DROP : à gérer plus tard si tu veux stocker l’ordre
          });

          setUserAnswers(reconstructedAnswers);
          setSubmitted(true);
          setResultSaved(true);
          console.log("✅ Réponses utilisateur restaurées :", reconstructedAnswers);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des réponses sauvegardées :", error);
      }
    };

    fetchInitialReview();
  }, [quizId]);

 

  // *** with refresh ***
  // const handleSubmit = async () => {
  //   setSubmitting(true);
  //   const scoreNow = questions.reduce(
  //     (sum, q) => isCorrect(q) ? sum + (q.score || 0) : sum,
  //     0
  //   );
  //   setScore(scoreNow);

  //   try {
  //     const user = JSON.parse(localStorage.getItem("user"));
  //     await courseService.submitQuizResult({
  //       userId: user.id,
  //       quizId: quizId,
  //       scoreObtained: scoreNow,
  //       scoreTotal: totalPossibleScore,
  //       answers: buildAnswersPayload(),
  //     });
  //     console.log("✅ Résultat du quiz soumis avec succès.");
  //     setResultSaved(true);
  //     setSubmitted(true);

  //     // 🔄 Déclenche un refresh de la progression
  //     setRefreshTrigger(prev => prev + 1);

  //   } catch (error) {
  //     console.error("❌ Erreur lors de la soumission du résultat :", error);
  //     alert("Une erreur est survenue lors de l'enregistrement du score.");
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

//// WIth Redux *******
const handleSubmit = async () => {
  setSubmitting(true);
  const scoreNow = questions.reduce(
    (sum, q) => (isCorrect(q) ? sum + (q.score || 0) : sum),
    0
  );
  setScore(scoreNow);

  try {
    const user = JSON.parse(localStorage.getItem("user"));
    await courseService.submitQuizResult({
      userId: user.id,
      quizId: quizId,
      scoreObtained: scoreNow,
      scoreTotal: totalPossibleScore,
      answers: buildAnswersPayload(),
    });
    console.log("✅ Résultat du quiz soumis avec succès.");
    setResultSaved(true);
    setSubmitted(true);

    // 🔄 Déclenche un refresh de la progression locale
    setRefreshTrigger(prev => prev + 1);

    // 🔥 Recalcule la note finale et met à jour Redux
    dispatch(recalculateNote(courseId, user.id));

  } catch (error) {
    console.error("❌ Erreur lors de la soumission du résultat :", error);
    alert("Une erreur est survenue lors de l'enregistrement du score.");
  } finally {
    setSubmitting(false);
  }
};


  useEffect(() => {
    const loadProgress = async () => {
      try {
        if (!courseId || !userId) {
          console.warn("❗ Paramètres manquants pour récupération du progrès");
          return;
        }

        // Appel à ton service backend
        const fetchedProgress = await courseService.CalculePrgresseByType(
          "controle",
          courseId,
          userId,
          quizId
        );

        console.log("📊 Progression récupérée du backend :", fetchedProgress);
        setProgress(fetchedProgress);
      } catch (err) {
        console.error("❌ Erreur lors de la récupération du progrès :", err);
      }
    };

    loadProgress();
  }, [courseId, userId, quizId, refreshTrigger]); // ⬅️ Ajout de refreshTrigger

  const renderQuizSummaryModal = () => (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FileTextOutlined style={{ color: "#1890ff", fontSize: 20 }} />
          <span style={{ fontSize: "18px", fontWeight: 600 }}>Résumé de vos réponses</span>
        </div>
      }
      open={showSummaryModal}
      onCancel={() => setShowSummaryModal(false)}
      onOk={async () => {
        setShowSummaryModal(false);
        await handleSubmit();
      }}
      okText="✅ Confirmer l'envoi"
      cancelText="✖️ Modifier mes réponses"
      okButtonProps={{ type: "primary" }}
      width={650}
    >
      <Divider style={{ margin: "10px 0 20px 0" }} />
      <List
        dataSource={questions}
        renderItem={(question, index) => {
          const userAnswer = userAnswers[question.id];
          const userText = Array.isArray(userAnswer)
            ? userAnswer.join(", ")
            : typeof userAnswer === "object"
              ? "[Réponse structurée]"
              : userAnswer || "Non répondu";

          return (
            <List.Item
              style={{
                backgroundColor: "#f9f9f9",
                borderLeft: "6px solid #1890ff",
                padding: "14px 18px",
                borderRadius: "10px",
                marginBottom: 10,
                transition: "transform 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.01)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <List.Item.Meta
                title={
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <Badge
                      count={`Q${index + 1}`}
                      style={{
                        backgroundColor: "#1890ff",
                        fontWeight: 600,
                      }}
                    />
                    <span style={{ fontWeight: 500 }}>{question.text}</span>
                  </div>
                }
                description={
                  <div style={{ marginTop: 4 }}>
                    <div style={{ marginTop: 4 }}>
                      <strong>Votre réponse :</strong> {userText}
                    </div>
                  </div>
                }
              />
            </List.Item>
          );
        }}
      />
      <Divider />
      <div style={{ textAlign: "center", color: "#888", fontSize: 13 }}>
        <InfoCircleTwoTone twoToneColor="#1890ff" /> Vérifiez vos réponses avant l’envoi définitif.
      </div>
    </Modal>
  );

  const isCorrect = (question) => {
    const userAnswer = userAnswers[question.id];

    if (question.questionType === "MATCHING") {
      if (!userAnswer) return false;
      return question.options.every(
        (pair) => userAnswer[pair.leftText] === pair.rightText
      );
    }

    const correct = question.correctAnswers;

    if (Array.isArray(userAnswer)) {
      return JSON.stringify(userAnswer.sort()) === JSON.stringify(correct.sort());
    }

    return userAnswer === correct[0];
  };

  const isValidHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent.trim().length > 0;
  }

  const calculateScore = () => {
    if (!submitted) return 0;
    return questions.reduce((sum, q) => isCorrect(q) ? sum + (q.score || 0) : sum, 0);
  };

  const totalPossibleScore = questions.reduce((sum, q) => sum + (q.score || 0), 0);

  // **** code avant rendre les réponses correcte avec couleur vert ******
  // const renderQuestion = (question) => {
  //   if (question.questionType === "QCU" || question.questionType === "VRAI_FAUX") {
  //     return (
  //       <Radio.Group
  //         value={userAnswers[question.id]}
  //         onChange={(e) => setUserAnswers({ ...userAnswers, [question.id]: e.target.value })}
  //         disabled={submitted}
  //         style={{ display: "flex", flexDirection: "column", gap: "10px" }}
  //       >
  //         {(question.options || []).map((option, i) => (
  //           <Radio key={i} value={option.text}>{option.text}</Radio>
  //         ))}
  //       </Radio.Group>
  //     );
  //   } else if (question.questionType === "QCM") {
  //     return (
  //       <Checkbox.Group
  //         value={userAnswers[question.id] || []}
  //         onChange={(values) => setUserAnswers({ ...userAnswers, [question.id]: values })}
  //         disabled={submitted}
  //         style={{ display: "flex", flexDirection: "column", gap: "10px" }}
  //       >
  //         {(question.options || []).map((option, i) => (
  //           <Checkbox key={i} value={option.text}>{option.text}</Checkbox>
  //         ))}
  //       </Checkbox.Group>
  //     );
  //   } else if (question.questionType === "DRAG_DROP") {
  //     return <DragDropPreview question={question} />;
  //   } else if (question.questionType === "MATCHING") {
  //     return (
  //       // <MatchingQuestionViewer
  //       //   pairs={question.options || []}
  //       //   questionId={question.id}
  //       //   userAnswers={userAnswers}
  //       //   setUserAnswers={setUserAnswers}
  //       //   disabled={submitted}
  //       // />
  //       <MatchingQuestionViewer
  //         key={submitted + JSON.stringify(userAnswers[question.id] || {})} // 🔁 force update
  //         pairs={question.options || []}
  //         questionId={question.id}
  //         userAnswers={userAnswers}
  //         setUserAnswers={setUserAnswers}
  //         disabled={submitted}
  //       />

  //     );
  //   } else {
  //     return <p style={{ color: "red" }}>❗ Type non supporté : {question.questionType}</p>;
  //   }
  // };
  // **** code Aprés rendre les réponses correcte avec couleur vert ******

  const renderQuestion = (question) => {
    const userAnswer = userAnswers[question.id];

    if (question.questionType === "QCU" || question.questionType === "VRAI_FAUX") {
      return (
        <Radio.Group
          value={userAnswer}
          onChange={(e) => setUserAnswers({ ...userAnswers, [question.id]: e.target.value })}
          disabled={submitted}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          {(question.options || []).map((option, i) => {
            const isSelected = userAnswer === option.text;
            const isCorrect = question.correctAnswers?.includes(option.text);
            const showFeedback = submitted;

            let backgroundColor = "transparent";
            if (showFeedback) {
              if (isCorrect) {
                backgroundColor = "#e8f5e9"; // vert clair
              } else if (isSelected && !isCorrect) {
                backgroundColor = "#ffebee"; // rouge clair
              }
            }

            return (
              <Radio
                key={i}
                value={option.text}
                style={{
                  backgroundColor,
                  borderRadius: "5px",
                  padding: "5px 10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {option.text}
                {showFeedback && isCorrect && (
                  <span style={{ marginLeft: "8px", color: "green" }}>✅</span>
                )}
                {showFeedback && isSelected && !isCorrect && (
                  <span style={{ marginLeft: "8px", color: "red" }}>❌</span>
                )}
              </Radio>
            );
          })}
        </Radio.Group>
      );
    }

    if (question.questionType === "QCM") {
      const selectedAnswers = userAnswer || [];

      return (
        <Checkbox.Group
          value={selectedAnswers}
          onChange={(values) => setUserAnswers({ ...userAnswers, [question.id]: values })}
          disabled={submitted}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          {(question.options || []).map((option, i) => {
            const isSelected = selectedAnswers.includes(option.text);
            const isCorrect = question.correctAnswers?.includes(option.text);
            const showFeedback = submitted;

            let backgroundColor = "transparent";
            if (showFeedback) {
              if (isCorrect) {
                backgroundColor = "#e8f5e9"; // vert
              } else if (isSelected && !isCorrect) {
                backgroundColor = "#ffebee"; // rouge
              }
            }

            return (
              <Checkbox
                key={i}
                value={option.text}
                style={{
                  backgroundColor,
                  borderRadius: "5px",
                  padding: "5px 10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {option.text}
                {showFeedback && isCorrect && (
                  <span style={{ marginLeft: "8px", color: "green" }}>✅</span>
                )}
                {showFeedback && isSelected && !isCorrect && (
                  <span style={{ marginLeft: "8px", color: "red" }}>❌</span>
                )}
              </Checkbox>
            );
          })}
        </Checkbox.Group>
      );
    }

    if (question.questionType === "DRAG_DROP") {
      return <DragDropPreview question={question} />;
    }

    if (question.questionType === "MATCHING") {
      return (
        <MatchingQuestionViewer
          key={submitted + JSON.stringify(userAnswers[question.id] || {})}
          pairs={question.options || []}
          questionId={question.id}
          userAnswers={userAnswers}
          setUserAnswers={setUserAnswers}
          disabled={submitted}
        />
      );
    }

    return <p style={{ color: "red" }}>❗ Type non supporté : {question.questionType}</p>;
  };



  if (loading) return <Spin tip="Chargement du quiz..." />;
  if (error) return <Alert message={error} type="error" />;
  if (!questions[currentStep]) return null;

  return (
    <div>
      {/* <Steps
        current={currentStep}
        onChange={(step) => submitted && setCurrentStep(step)}
        style={{ marginBottom: 20 }}
      >
        {questions.map((q, index) => {
          let status = "wait";
          if (submitted) {
            status = isCorrect(q) ? "finish" : "error";
          }
          return (
            <Step
              key={q.id}
              title={
                <span style={{
                  fontWeight: currentStep === index ? "bold" : "normal",
                  color: currentStep === index ? "#1890ff" : undefined
                }}>
                  Q{index + 1}
                </span>
              }
              status={status}
            />
          );
        })}
      </Steps> */}
      <Steps
        current={currentStep}
        onChange={(step) => submitted && setCurrentStep(step)}
        style={{ marginBottom: 20 }}
      >
        {questions.map((q, index) => {
          const correct = isCorrect(q);
          const isActive = currentStep === index;

          const icon = submitted ? (
            correct ? (
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            ) : (
              <CloseCircleTwoTone twoToneColor="#ff4d4f" />
            )
          ) : undefined;

          return (
            <Step
              key={q.id}
              icon={icon}
              title={
                <span style={{
                  fontWeight: isActive ? "bold" : "normal",
                  color: submitted
                    ? correct
                      ? "#52c41a"  // vert pour bonne réponse
                      : "#ff4d4f"  // rouge pour mauvaise réponse
                    : isActive
                      ? "#1890ff"
                      : undefined
                }}>
                  Q{index + 1}
                </span>
              }
            />
          );
        })}
      </Steps>

      {submitted && (
        <div style={{ textAlign: "right", marginBottom: 10 }}>
          <strong style={{ fontSize: 16 }}>
            🎯 Score : {calculateScore()} / {totalPossibleScore}
          </strong>
        </div>
      )}

      <Card
        title={`Question ${currentStep + 1}: ${questions[currentStep].text || "Sans titre"} (${questions[currentStep].score || 0} pts)`}
        style={{ marginBottom: "20px" }}
      >
        {renderQuestion(questions[currentStep])}

        {submitted && (
          <div style={{
            marginTop: "16px",
            padding: "12px",
            backgroundColor: isCorrect(questions[currentStep]) ? "#e8f5e9" : "#ffebee",
            borderRadius: "8px"
          }}>
            <strong style={{ color: isCorrect(questions[currentStep]) ? "#2e7d32" : "#c62828" }}>
              {isCorrect(questions[currentStep]) ? "✔ Bonne réponse" : "✘ Mauvaise réponse"}
            </strong>

            {/* {questions[currentStep].explanation && questions[currentStep].explanation.trim() !== "" && (
              <div style={{ marginTop: "8px" }}>
                <strong>Explication :</strong>{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: questions[currentStep].explanation,
                  }}
                />
              </div>
            )} */}
            {/* ✅ Affichage conditionnel de l'explication (s'il y a du vrai contenu) */}
            {questions[currentStep].explanation &&
              isValidHtml(questions[currentStep].explanation) && (
                <div style={{ marginTop: "8px" }}>
                  <strong>Explication :</strong>{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: questions[currentStep].explanation,
                    }}
                  />
                </div>
              )}


          </div>
        )}
      </Card>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button onClick={() => setCurrentStep((prev) => prev - 1)} disabled={currentStep === 0}>
          Précédent
        </Button>

        {/* {currentStep < questions.length - 1 ? (
          <Button onClick={() => setCurrentStep((prev) => prev + 1)}>
            Suivant
          </Button>
        ) : (
          !submitted && (
            <Button type="primary" onClick={handleSubmit}>
              Soumettre
            </Button>
          )
        )} */}
        {currentStep < questions.length - 1 ? (
          <Button onClick={() => setCurrentStep((prev) => prev + 1)}>
            Suivant
          </Button>
        ) : (
          !submitted && (
            <Button
              type="primary"
              onClick={() => setShowSummaryModal(true)}
              loading={submitting}
              disabled={submitting}
              style={{
                backgroundColor: submitting ? "#d4b106" : undefined,
                borderColor: submitting ? "#d4b106" : undefined,
                color: submitting ? "#fff" : undefined,
              }}
            >
              {submitting ? "Envoi en cours..." : "Soumettre"}
            </Button>
          )
        )}


      </div>

      {submitted && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
            <Button
              type="default"
              disabled={attemptOnce}
              onClick={() => {
                if (!attemptOnce) {
                  setSubmitted(false);
                  setUserAnswers({});
                  setCurrentStep(0);
                }
              }}
            >
              Recommencer
            </Button>

            <span style={{ fontWeight: "bold", color: attemptOnce ? "red" : "green" }}>
              🔒 Ce quiz est {attemptOnce ? "limité à une seule tentative" : "rejouable"}.
            </span>
          </div>
          <Card
            title={
              <span style={{ fontSize: "18px", fontWeight: "bold", color: "#1890ff" }}>
                <FileTextOutlined /> Résultat progression
              </span>
            }
            bordered={true}
            style={{
              maxWidth: 600,
              margin: "20px auto",
              borderRadius: "12px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {progress && progress.length > 0 ? (
              <List
                itemLayout="horizontal"
                dataSource={progress}
                renderItem={(item) => {
                  const pct = item.pct ?? 0;
                  const icon =
                    pct >= 80 ? (
                      <CheckCircleTwoTone twoToneColor="#52c41a" />
                    ) : pct >= 50 ? (
                      <InfoCircleTwoTone twoToneColor="#faad14" />
                    ) : (
                      <CloseCircleTwoTone twoToneColor="#ff4d4f" />
                    );

                  const color =
                    pct >= 80 ? "green" : pct >= 50 ? "orange" : "red";

                  return (
                    <List.Item
                      style={{
                        backgroundColor: "#fafafa",
                        marginBottom: "10px",
                        padding: "12px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                      }}
                    >
                      <List.Item.Meta
                        avatar={icon}
                        title={
                          <span style={{ fontWeight: "bold", color: "#333" }}>
                            Quiz N° : {item.quizId ?? "N/A"}
                          </span>
                        }
                        description={
                          <>
                            <Progress
                              percent={pct}
                              status={pct >= 80 ? "success" : pct >= 50 ? "active" : "exception"}
                              size="small"
                              strokeColor={color}
                            />
                            <Tag color={color} style={{ marginTop: "5px" }}>
                              {item.scoreObtained ?? 0}/{item.scoreTotal ?? 0} points
                            </Tag>
                          </>
                        }
                      />
                    </List.Item>
                  );
                }}
              />
            ) : (
              <p style={{ textAlign: "center", color: "#999" }}>Aucune donnée trouvée.</p>
            )}
          </Card>
        </div>
      )}



      {renderQuizSummaryModal()}

      {/* {renderReviewResults()} */}





    </div>
  );
};

export default TestDeConnaissance;
